import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserOrganisationInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserOrganisationInfoQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, organisationInfo?: { __typename?: 'OrganisationInfo', uuid: string, name: string, type?: Types.OrganisationType | null, role: Types.OrganisationRole, teams: Array<{ __typename?: 'TeamInfo', uuid: string, name: string, role: Types.OrganisationTeamRole, postsScreeningEnabled: boolean }> } | null } };


export const GetCurrentUserOrganisationInfoDocument = gql`
    query GetCurrentUserOrganisationInfo {
  currentUser {
    id
    organisationInfo {
      uuid
      name
      type
      role
      teams {
        uuid
        name
        role
        postsScreeningEnabled
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserOrganisationInfoQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserOrganisationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserOrganisationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserOrganisationInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserOrganisationInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>(GetCurrentUserOrganisationInfoDocument, options);
      }
export function useGetCurrentUserOrganisationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>(GetCurrentUserOrganisationInfoDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserOrganisationInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>;
export function useGetCurrentUserOrganisationInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserOrganisationInfoQuery | undefined, GetCurrentUserOrganisationInfoQueryVariables>;
export function useGetCurrentUserOrganisationInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>(GetCurrentUserOrganisationInfoDocument, options);
        }
export type GetCurrentUserOrganisationInfoQueryHookResult = ReturnType<typeof useGetCurrentUserOrganisationInfoQuery>;
export type GetCurrentUserOrganisationInfoLazyQueryHookResult = ReturnType<typeof useGetCurrentUserOrganisationInfoLazyQuery>;
export type GetCurrentUserOrganisationInfoSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserOrganisationInfoSuspenseQuery>;
export type GetCurrentUserOrganisationInfoQueryResult = Apollo.QueryResult<GetCurrentUserOrganisationInfoQuery, GetCurrentUserOrganisationInfoQueryVariables>;